<div *ngIf="flattenHeaders" [class.additional]="headerInfo.length > 1" class="header-test-info">
         <span *ngFor="let headerInfoData of headerInfo">
           <span *ngIf="headerInfoData.cssClassAvailable">
              <span class="{{headerInfoData.cssClass}}" translate>{{headerInfoData.name}}</span>
              <span *ngFor="let headerInfoValue of headerInfoData.values; trackBy: trackByIndex"
                    class="{{headerInfoData.cssClass}}">{{headerInfoValue}} </span>
           </span>
           <span *ngIf="headerInfoData.cssClassAvailable === false">
                 <span class="additional-test-data-caption" translate>{{headerInfoData.name}}</span>
                  <span *ngFor="let headerInfoValue of headerInfoData.values; trackBy: trackByIndex"
                        class="additional-test-data-value">{{headerInfoValue}} </span>
           </span>

        </span>
</div>

<div (mouseenter)="showInfo = true" (mouseleave)="showInfo = false" *ngIf="flattenHeaders === false"
     [class.additional]="headerInfo.length > 1" class="header-test-info">
        <span>
          <span (click)="showInfo = !showInfo;" class="additional-test-data-caption {{headerInfo[0].cssClass}}"
                translate>
            {{headerInfo[0].name}}
          </span>
          <span (click)="showInfo = !showInfo;"
                *ngFor="let headerInfoValue of headerInfo[0].values; trackBy: trackByIndex" class="additional-test-data-value {{headerInfo[0].cssClass}}">
            {{headerInfoValue}}
          </span>
        </span>
    <ul *ngIf="headerInfo.length>1" [ngClass]="{'hidden':!showInfo}" class="additional-test-data">
        <li *ngFor="let headerInfoData of headerInfo.slice(1)">
            <span class="additional-test-data-caption" translate>{{headerInfoData.name}}</span>
            <span *ngFor="let headerInfoValue of headerInfoData.values; trackBy: trackByIndex"
                  class="additional-test-data-value">{{headerInfoValue}} </span>
        </li>
    </ul>
</div>
